function Error() {
  return (
    <section className="section">
      <div className="container has-text-centered">
        <h2 className="title is-1">⚠ Somethings gone wrong! Please try again or contact the adminstrator. ⚠</h2>
      </div>
    </section>
  )
}

export default Error